import React, {memo, useCallback, useEffect, useState} from "react"
import {ControlModel} from "../../../types/control"
import {Column} from "../../Column"
import {Widget} from "../../Widget"
import {onClickHandler} from "../../../utils/onclick"
import minusIcon from "../../../assets/images/icons/controls/minus.png"
import plusIcon from "../../../assets/images/icons/controls/plus.png"
import controlIcon from "../../../assets/images/icons/controls/vrf/vrf.png"

import iconRight from "../../../assets/images/icons/media/right.png"
import iconLeft from "../../../assets/images/icons/media/left.png"
import "./index.scss"

type Props = {
    control: ControlModel
    onClickPower: () => void
    powerIcon: string
    onClickMode: () => void
    modeIcon: string
    onClickVentilate: () => void
    ventilateIcon: string
    onClickFlap?: (isPlus: boolean) => void
    flapIcon?: string
    onClickFan?: (isPlus: boolean) => void
    fanIcon?: string
    onClickTemp: (isPlus: boolean) => void
    tempValue: string
    disability: boolean
    accessDenied?: boolean
}

export const VRFControlComponent = memo(function VRFControlComponent(props: Props) {
    const {
        control,
        powerIcon,
        onClickPower,
        onClickMode,
        onClickVentilate,
        onClickFlap,
        onClickFan,
        onClickTemp,
        disability,
        modeIcon,
        ventilateIcon,
        flapIcon,
        fanIcon,
        tempValue,
        accessDenied = false
    } = props

    return (
        <Column min={6} max={12}>
            <Widget>
                <div className="position-relative">
                    <div className="vrf-wrapper">
                        {renderIf(!accessDenied)(
                            () => (
                                <>
                                    <div className="vrf-top-box">
                                        <div className="vrf-img-box">
                                            <img src={controlIcon} alt="img" />
                                        </div>
                                        <span>{control.name}</span>
                                    </div>
                                    <div className="vrf-content-box">
                                        <div className="vrf-content-left">
                                            <button className={`vrf-button`} {...onClickHandler(onClickPower)}>
                                                <img src={powerIcon} alt="img" />
                                            </button>
                                            <button className="vrf-button" style={{visibility: "hidden"}}>
                                                <img src={null} alt="img" />
                                            </button>
                                            <button
                                                className={`vrf-button`}
                                                {...onClickHandler(onClickMode)}
                                                disabled={!disability && true}
                                            >
                                                <img
                                                    src={modeIcon}
                                                    alt="img"
                                                    style={{maxWidth: "55px", maxHeight: "55px"}}
                                                />
                                            </button>
                                            <button
                                                className="vrf-button"
                                                {...onClickHandler(onClickVentilate)}
                                                disabled={!disability && true}
                                            >
                                                <img
                                                    src={ventilateIcon}
                                                    alt="img"
                                                    style={{maxWidth: "55px", maxHeight: "55px"}}
                                                />
                                            </button>
                                        </div>
                                        <div className="vrf-content-right">
                                            <div className="vrf-actions">
                                                <span>{tempValue}°</span>
                                                <div className="vrf-action-buttons">
                                                    <button
                                                        className="vrf-button"
                                                        style={{marginRight: "0.8rem"}}
                                                        disabled={!disability && true}
                                                        {...onClickHandler(() => onClickTemp(false))}
                                                    >
                                                        <img src={minusIcon} alt="img" />
                                                    </button>
                                                    <button
                                                        className="vrf-button"
                                                        disabled={!disability && true}
                                                        {...onClickHandler(() => onClickTemp(true))}
                                                    >
                                                        <img src={plusIcon} alt="img" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="vrf-actions">
                                                <span>
                                                    <img src={flapIcon} alt="" />
                                                </span>
                                                <div className="vrf-action-buttons">
                                                    <button
                                                        className="vrf-button"
                                                        style={{marginRight: "0.8rem"}}
                                                        disabled={!disability && true}
                                                        {...onClickHandler(() => onClickFlap(false))}
                                                    >
                                                        <img src={iconLeft} alt="img" />
                                                    </button>
                                                    <button
                                                        className="vrf-button"
                                                        disabled={!disability && true}
                                                        {...onClickHandler(() => onClickFlap(true))}
                                                    >
                                                        <img src={iconRight} alt="img" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="vrf-actions">
                                                <span>
                                                    <img src={fanIcon} alt="" />
                                                </span>
                                                <div className="vrf-action-buttons">
                                                    <button
                                                        className="vrf-button"
                                                        style={{marginRight: "0.8rem"}}
                                                        disabled={!disability && true}
                                                        {...onClickHandler(() => onClickFan(false))}
                                                    >
                                                        <img src={iconLeft} alt="img" />
                                                    </button>
                                                    <button
                                                        className="vrf-button"
                                                        disabled={!disability && true}
                                                        {...onClickHandler(() => onClickFan(true))}
                                                    >
                                                        <img src={iconRight} alt="img" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ),
                            () => (
                                <div className="access-denied">Cihaza ulaşılamıyor</div>
                            )
                        )}
                    </div>
                </div>
            </Widget>
        </Column>
    )
})
